import { Sprite } from 'pixi.js';
import { _screenX, _screenY } from '../../../../services/canvas/canvas.service';
import { ImageBgOptions } from '../../../../elements/resource/types/shape.type';
import { BackgroundService } from '../../../store/studio/background/background.service';
import {
  CanvasBackground,
  CanvasBackgroundConfig,
} from '../../canvas-background';

export class ImageBackground extends CanvasBackground {
  constructor(
    bgService: BackgroundService,
    private readonly options: ImageBgOptions,
    config: CanvasBackgroundConfig = {},
  ) {
    super(bgService, config);
    this.init();
  }

  addToCanvas() {
    this.container.removeChildren();
    this.container.addChild(this.bg);
  }

  // sprite: Sprite;

  private init() {
    const {
      url,
      fit = 'cover',
      alpha = 1,
      scale: userScale,
      translate,
    } = this.options || ({} as ImageBgOptions);
    if (!url) return;

    const src = url.startsWith('http')
      ? url
      : `https://private.cdn.inwedio.com/${url}`;
    const sprite = Sprite.from(src);
    sprite.alpha = alpha;
    sprite.anchor.set(0, 0);

    const applyFit = () => {
      const texW = sprite.texture.width;
      const texH = sprite.texture.height;
      if (!texW || !texH) return;

      const screenW = _screenX;
      const screenH = _screenY;
      const scaleX = screenW / texW;
      const scaleY = screenH / texH;

      if (fit === 'stretch') {
        sprite.scale.set(scaleX, scaleY);
        sprite.x = 0;
        sprite.y = 0;
      } else {
        const baseScale =
          fit === 'contain'
            ? Math.min(scaleX, scaleY)
            : Math.max(scaleX, scaleY); // cover default
        sprite.scale.set(baseScale);
        sprite.x = (screenW - texW * baseScale) / 2;
        sprite.y = (screenH - texH * baseScale) / 2;
      }

      // Apply additional zoom (scale) centered on the screen
      if (userScale !== undefined && userScale !== 1) {
        const sx = sprite.scale.x * userScale;
        const sy = sprite.scale.y * userScale;
        sprite.scale.set(sx, sy);
        sprite.x = (screenW - texW * sx) / 2;
        sprite.y = (screenH - texH * sy) / 2;
      }

      // Apply translate offset (in pixels)
      if (translate) {
        sprite.x += translate[0];
        sprite.y += translate[1];
      }
    };

    if (sprite.texture.valid) {
      applyFit();
    } else {
      // When the base texture finishes loading, fit and position
      sprite.texture.baseTexture.once('loaded', applyFit);
    }

    // Clip to screen area and add to the correct container
    sprite.mask = this.screenRectangle.element;
    this.container.addChild(sprite);
    // save as bg for consistency with other backgrounds
    (this as any).bg = sprite;
  }

  // Static background, no timeline at the moment
  setStateByTime(_time: number): void {}
}
